export const getCsrfToken = () : string => {
  const meta = document.querySelector('meta[name=csrf-token]') as HTMLMetaElement
  return meta.content;
}